import * as React from "react";
const SvgChatPermissionsIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 20, fill: "none", viewBox: "0 0 18 20", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 6.085, cy: 7.085, r: 6.085, fill: "#a5beff", style: {
  fill: "#a5beff",
  fill: "color(display-p3 .6471 .7451 1)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { fill: "#e1ebff", d: "M5.334 2.873a.98.98 0 0 1 1.502 0l1.19 2.11 1.797 1.5c.29.351.29.853 0 1.204l-1.798 1.5-1.189 2.11a.978.978 0 0 1-1.502 0l-1.19-2.11-1.797-1.5a.94.94 0 0 1 0-1.203l1.798-1.501z", style: {
  fill: "#e1ebff",
  fill: "color(display-p3 .8824 .9216 1)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("rect", { width: 13, height: 13, x: 4.5, y: 6.5, fill: "#cbd5db", rx: 3.5, style: {
  fill: "#cbd5db",
  fill: "color(display-p3 .7961 .8351 .8577)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("rect", { width: 13, height: 13, x: 4.5, y: 6.5, stroke: "#fff", rx: 3.5, style: {
  stroke: "#fff",
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { stroke: "#214b64", strokeLinecap: "round", strokeLinejoin: "round", d: "M11 16.6c.72 0 1.68-.48 1.68-.48l1.619.48a.297.297 0 0 0 .301-.3l-.48-1.14c.458-.782.48-2.16.48-2.16a3.6 3.6 0 1 0-4.978 3.326c.437.181.658.274 1.378.274", style: {
  stroke: "#214b64",
  stroke: "color(display-p3 .1299 .2942 .3928)",
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { stroke: "#214b64", strokeLinejoin: "round", strokeWidth: 0.75, d: "M9.5 12H13m-3.5 2H12", style: {
  stroke: "#214b64",
  stroke: "color(display-p3 .1299 .2942 .3928)",
  strokeOpacity: 1
} }));
export default SvgChatPermissionsIcon;
